import { useState } from "react";
import {
  Checkbox,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  TextField,
  Typography,
} from "@mui/material";

import { SettingDialog } from "../SettingDialog";
import { CleaningRobotItem } from "types/response/robot";
import { useUpdateRobotMutation } from "hooks/worker/useRobot";
import { handleError } from "utils/error/handleError";

interface SettingRobotDialogProps {
  open: boolean;
  robot: CleaningRobotItem;
  hideEnabledSetting?: boolean;
  onClickSave: () => void;
  onClickCancel: () => void;
}

export const SettingRobotDialog = (props: SettingRobotDialogProps) => {
  const [editingRobot, setEditingRobot] = useState<CleaningRobotItem>(
    props.robot
  );
  const [robotName, setRobotName] = useState<string>(props.robot.robotName);
  const [description, setDescription] = useState<string | undefined>(
    props.robot.description
  );
  const [error, setError] = useState("");
  const updateMutation = useUpdateRobotMutation();

  const onClickSave = () => {
    setError("");
    if (!editingRobot.robotName) {
      setError("ロボット名を入力してください。");
      return;
    }

    updateMutation.mutate(
      { robotId: props.robot.robotId, robotName, description },
      {
        onError: (e) => {
          handleError(e);
        },
        onSuccess: () => {
          props.onClickSave();
        },
      }
    );
  };

  return (
    <SettingDialog
      open={props.open}
      onClickClose={props.onClickCancel}
      onClickSave={onClickSave}
    >
      <DialogTitle>「{props.robot.robotName}」の設定</DialogTitle>
      <DialogContent
        sx={{
          display: "grid",
          border: "1px gray solid",
          borderRadius: "4px",
          mt: 2,
        }}
      >
        <TextField
          required
          label="ロボット名"
          value={robotName}
          onChange={(e) => setRobotName(e.target.value)}
          sx={{ mt: 4 }}
        ></TextField>

        <TextField
          label="説明"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          minRows={3}
          multiline
          sx={{ mt: 2 }}
        />
        {!props.hideEnabledSetting && (
          <>
            <FormControlLabel
              control={
                <Checkbox
                  defaultChecked={editingRobot.enabled}
                  onChange={(e) =>
                    setEditingRobot((prev) => ({
                      ...prev,
                      enabled: e.target.checked,
                    }))
                  }
                />
              }
              label="有効"
              labelPlacement="start"
              sx={{ mt: 2, ml: 0, justifyContent: "left" }}
            />
            <Typography variant={"caption"}>
              ※ 不要なロボットを非表示にする場合に、チェックを外してください。
            </Typography>
          </>
        )}

        <Typography variant={"caption"} color={"error"}>
          {error}
        </Typography>
      </DialogContent>
    </SettingDialog>
  );
};
